import Hero from "@/components/sections/Hero";
import ServicesSection from "@/components/sections/ServicesSection";
import ServiceChecklistSection from "@/components/sections/ServiceChecklistSection";
import BrandShowcaseSection from "@/components/sections/BrandShowcaseSection";
import WhyUs from "@/components/sections/WhyUs";
import InciAkuPromo from "@/components/sections/InciAkuPromo";
import Testimonials from "@/components/sections/Testimonials";
import FaqAndCampaigns from "@/components/sections/FaqAndCampaigns";
import QuickQuoteForm from "@/components/sections/QuickQuoteForm";
import MapEmbed from "@/components/sections/MapEmbed";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Hero />
      <ServiceChecklistSection />
      <BrandShowcaseSection />
      <ServicesSection />
      <InciAkuPromo />
      <WhyUs />
      <Testimonials />
      <FaqAndCampaigns />
      <QuickQuoteForm />
      <section className="relative pb-24 lg:pb-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-10">
            <p className="text-gold uppercase tracking-[0.4em] text-xs mb-3">
              Konum
            </p>
            <h2 className="font-display text-3xl sm:text-4xl font-bold">
              <span className="text-gradient-silver">Bize </span>
              <span className="text-gradient-gold">en kolay yoldan ulaşın.</span>
            </h2>
          </div>
          <MapEmbed />
        </div>
      </section>
    </div>
  );
}
